module.exports = __webpack_public_path__ + "static/img/2.d879c1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/dishini/2.jpg
// module id = 8rZA
// module chunks = 1